import { APIResponse } from '@cbgms/api/helpers'
import { CountryCode } from '@carsys/enums/country-code'

export type GETLocationQueryParams = Partial<{
  Address: string
  AddressExtra: string
  City: string
  Country: CountryCode
  HouseNumber: string
  HouseNumberAddition: string
  Latitude: string
  Longitude: string
  PostalCode: string
  State: string
  ResolveCoordinatesOnly: boolean
}>

interface Address {
  PostalCode: string
  City: string
  State: string
  Country: string
  AddressLines: string[]
}

interface Coordinates {
  Latitude: number
  Longitude: number
}

export type GETLocationResponse = APIResponse<{
  Address: Address
  Coordinates: Coordinates
  FormattedAddress: string
}>

export const getLocationRequest = (params: GETLocationQueryParams) => {
  return {
    method: 'GET',
    params,
    url: '/modules/location'
  }
}
